export default {
    en: {
        entrance: 'Entrance',
        exit: 'Exit',
        selectDevice: 'Please select device',
        entranceInput: 'Please enter entrance name',
        exitInput: 'Please enter exit name',
        attrOutput: 'Attribute Output',
        faceAttrRecognition: 'Face Attribute Recognition',
        bodyAttrRecognition: 'Body Attribute Recognition',
        age: 'Age',
        gender: 'Gender',
        faceAttr: 'Face Attribute',
        bodyAttr: 'Body Attribute',
    },
    zh: {
        entrance: '入口设置',
        exit: '出口设置',
        selectDevice: '请选择设备',
        entranceInput: '请输入入口名称',
        exitInput: '请输入出口名称',
        attrOutput: '属性输出',
        faceAttrRecognition: '人脸属性识别',
        bodyAttrRecognition: '人体属性识别',
        age: '年龄',
        gender: '性别',
        faceAttr: '人脸属性',
        bodyAttr: '人体属性',
    },
};
